// extracted by mini-css-extract-plugin
module.exports = {"textarea":"CounselorMessagesImpl_textarea_2vADx","textareaCounter":"CounselorMessagesImpl_textareaCounter_137Ev"};